import { render, staticRenderFns } from "./r-smart-offer-bundle-christmas-calendar.vue?vue&type=template&id=58a558c7"
import script from "./r-smart-offer-bundle-christmas-calendar.vue?vue&type=script&lang=js"
export * from "./r-smart-offer-bundle-christmas-calendar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/mira-merge-config/mira-merge-config/app-config/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('58a558c7')) {
      api.createRecord('58a558c7', component.options)
    } else {
      api.reload('58a558c7', component.options)
    }
    module.hot.accept("./r-smart-offer-bundle-christmas-calendar.vue?vue&type=template&id=58a558c7", function () {
      api.rerender('58a558c7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/redactor/views/smart-offer/bundle-christmas-calendar/r-smart-offer-bundle-christmas-calendar.vue"
export default component.exports